const FOOTER_REFERRAL_BASE = 'https://www.beehiiv.com/powered-by';

export type FooterReferralUrlParams = {
  publicationName?: string | null;
  publicationLogoUrl?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
};

const setIfPresent = (params: URLSearchParams, key: string, value?: string | null) => {
  if (value) {
    params.set(key, value);
  }
};

export const buildFooterReferralUrl = ({
  publicationName,
  publicationLogoUrl,
  utmSource,
  utmMedium = 'footer',
  utmCampaign,
}: FooterReferralUrlParams): string => {
  const params = new URLSearchParams();

  setIfPresent(params, 'publication_name', publicationName);
  setIfPresent(params, 'publication_logo', publicationLogoUrl);
  setIfPresent(params, 'utm_source', utmSource);
  setIfPresent(params, 'utm_medium', utmMedium);
  setIfPresent(params, 'utm_campaign', utmCampaign);

  const query = params.toString();
  return query ? `${FOOTER_REFERRAL_BASE}?${query}` : FOOTER_REFERRAL_BASE;
};
